/**
 * @requirement S-041 AC #1 — "Hero renders wordmark + tagline per
 *   brand v0.2".
 *
 * Wordmark + tagline, minimal chrome. Consumers wrap this above the
 * DropZone. `<h1>` for the wordmark so the landing route has a
 * proper document title in the accessibility tree.
 */

import type { ReactElement } from 'react';

export function Hero(): ReactElement {
  return (
    <header className="flex flex-col items-center gap-3 text-center">
      <h1
        id="landing-heading"
        className="font-serif text-5xl font-semibold tracking-tight text-chrome-text-primary"
      >
        Recto
      </h1>
      <p className="max-w-md text-lg text-chrome-text-secondary">
        Edit any PDF, in your browser. No upload. No sign-in.
      </p>
    </header>
  );
}
